import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-wallet': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M156.8 126.8C194.4 187.4 221 239.9 241.1 289.3 232.8 323.1 222.3 355.8 209.8 387.6 196.6 335.3 183.3 286.3 153.8 239.1 160.3 202.7 156.1 165.5 156.8 126.8zM109.3 200H16.1C9.6 200 5.6 207.5 9.6 212.7 51.8 267 81.3 330.5 101.3 400H204.8C188.6 330.3 166.1 266.3 122.3 206.5 119.3 202.5 114.3 200 109.3 200zM157.1 112C225.6 220 287.1 346.5 295.3 480H409C397 342 340.6 215 265.8 112H157.1zM408.9 43.5C407.1 36.7 400.7 32 393.7 32H305.4C300.1 32 296.4 37 297.6 42.3 310.8 88.8 319.9 137.8 324.1 188.3 372.3 274.5 403.8 366.6 414.7 459.1 430.5 398.6 440 325.6 440 256.1 440 182.5 427.9 111 408.9 43.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-wallet.js
// module id = QuxI
// module chunks = 144